export const initialState = {
  totalTaps: 0,
  combo: 0,
  maxCombo: 0,
  lastTapTime: 0,
  currentType: 'merit',
  achievements: [],
  unlockedAchievements: [],
  autoTapActive: false,
  autoTapCount: 0,
  autoTapTotal: 0,
  sessionTaps: 0,
  fastestTapInterval: Infinity,
  longestPlaySession: 0,
  sessionStartTime: Date.now(),
  currentSpecialFish: 'normal',
  typeStats: {
    merit: { tapCount: 0 },
    love: { tapCount: 0 },
    wealth: { tapCount: 0 },
    health: { tapCount: 0 },
  },
  // 統計
  nightTaps: 0,
  morningTaps: 0,
  perfectCombo: 0,
  lastTapIntervals: [],
  comboRecoveries: 0,
  lastComboLost: false,
  // 每日登入
  loginDays: 0,
  lastLoginDate: '',
  dailyRewardClaimed: false,
  // 🔔 未查看的通知
  unviewedAchievements: [],
  unviewedFish: [],
};

export const gameReducer = (state, action) => {
  switch (action.type) {
    case 'LOAD_STATE':
      return {
        ...state,
        ...action.payload,
        unviewedAchievements: action.payload.unviewedAchievements || [],
        unviewedFish: action.payload.unviewedFish || [],
        comboRecoveries: action.payload.comboRecoveries || 0,
        lastComboLost: action.payload.lastComboLost || false,
        loginDays: action.payload.loginDays || 0,
        lastLoginDate: action.payload.lastLoginDate || '',
        dailyRewardClaimed: action.payload.dailyRewardClaimed || false,
      };

    // 🔥 每日登入檢查
    case 'CHECK_DAILY_LOGIN': {
      const today = new Date().toDateString();
      const lastLogin = state.lastLoginDate;
      if (lastLogin === today) {
        return state; // 今天已登入
      }
      const yesterday = new Date(Date.now() - 86400000).toDateString();
      const isConsecutive = lastLogin === yesterday;
      const newLoginDays = isConsecutive ? state.loginDays + 1 : 1;
      return {
        ...state,
        loginDays: newLoginDays,
        lastLoginDate: today,
        dailyRewardClaimed: false,
      };
    }

    // 🔥 領取每日獎勵
    case 'CLAIM_DAILY_REWARD': {
      if (state.dailyRewardClaimed) return state;
      return {
        ...state,
        dailyRewardClaimed: true,
        totalTaps: state.totalTaps + 100, // 功德紅包效果
      };
    }

    case 'TAP_MOKUGYO': {
      const now = Date.now();
      const timeSinceLastTap = now - state.lastTapTime;
      const newCombo = timeSinceLastTap < 2000 ? state.combo + 1 : 1;
      const wasComboLost = timeSinceLastTap >= 2000 && state.combo > 0;
      const isRecovering = wasComboLost && newCombo >= 10;
      const newComboRecoveries = isRecovering ? state.comboRecoveries + 1 : state.comboRecoveries;
      const hour = new Date().getHours();
      const isNight = hour >= 0 && hour < 6;
      const isMorning = hour >= 6 && hour < 9;
      const isPerfectTiming = timeSinceLastTap >= 1000 && timeSinceLastTap <= 2000;
      const newPerfectCombo = isPerfectTiming && state.combo > 0 ? state.perfectCombo + 1 : 0;
      const intervals = [...state.lastTapIntervals, timeSinceLastTap].slice(-20);
      return {
        ...state,
        totalTaps: state.totalTaps + 1,
        sessionTaps: state.sessionTaps + 1,
        combo: newCombo,
        maxCombo: Math.max(state.maxCombo, newCombo),
        lastTapTime: now,
        fastestTapInterval:
          timeSinceLastTap > 0 && timeSinceLastTap < state.fastestTapInterval
            ? timeSinceLastTap
            : state.fastestTapInterval,
        nightTaps: isNight ? state.nightTaps + 1 : state.nightTaps,
        morningTaps: isMorning ? state.morningTaps + 1 : state.morningTaps,
        perfectCombo: newPerfectCombo,
        lastTapIntervals: intervals,
        comboRecoveries: newComboRecoveries,
        lastComboLost: wasComboLost,
        typeStats: {
          ...state.typeStats,
          [state.currentType]: {
            ...state.typeStats[state.currentType],
            tapCount: state.typeStats[state.currentType].tapCount + 1,
          },
        },
      };
    }

    case 'CHANGE_TYPE':
      return { ...state, currentType: action.payload };

    case 'TOGGLE_AUTO_TAP': {
      const isActivating = !state.autoTapActive;
      return {
        ...state,
        autoTapActive: isActivating,
        autoTapCount: isActivating ? state.autoTapCount + 1 : state.autoTapCount,
      };
    }

    case 'AUTO_TAP_TICK':
      return { ...state, autoTapTotal: state.autoTapTotal + 1 };

    case 'SELECT_SPECIAL_FISH':
      return { ...state, currentSpecialFish: action.payload };

    case 'UNLOCK_ACHIEVEMENT':
      if (state.unlockedAchievements.includes(action.payload.id)) return state;
      return {
        ...state,
        unlockedAchievements: [...state.unlockedAchievements, action.payload.id],
        achievements: [
          ...state.achievements,
          { ...action.payload, unlockTime: new Date().toISOString() },
        ],
        unviewedAchievements: [...state.unviewedAchievements, action.payload.id],
      };

    case 'UNLOCK_FISH':
      return { ...state, unviewedFish: [...state.unviewedFish, action.payload] };

    case 'MARK_ACHIEVEMENTS_VIEWED':
      return { ...state, unviewedAchievements: [] };

    case 'MARK_FISH_VIEWED':
      return { ...state, unviewedFish: [] };

    default:
      return state;
  }
};